module.exports = __webpack_public_path__ + "img/T7A6698.e1e2467f.jpg";